/**
 * Usage strip under the chat header. Phones get one compact row instead of
 * three tall cards, so the conversation owns the screen (VIS-CORE-8).
 */
import React from 'react';
import { View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Text } from '@/components/ui/text';
import { reviewDesk } from '@/design-system';
import { webChatStyles } from '../chatStyles';
import type { ChatUsageCard } from '../chatUsage';

export function ChatUsageStrip({ cards, isPhone, isCompact }: { cards: ChatUsageCard[]; isPhone: boolean; isCompact: boolean }) {
  if (isPhone) {
    return (
      <View style={webChatStyles.usageRowPhone} testID="chat_usage_row">
        {cards.map((item) => (
          <View
            key={item.key}
            testID={item.key === 'trial-chat' ? 'trial_chat_usage_badge' : undefined}
            style={webChatStyles.usageCellPhone}
            accessibilityLabel={`${item.label}: ${item.value}. ${item.meta}`}
          >
            <MaterialIcons name={item.icon} size={15} color={reviewDesk.accent} />
            <Text style={webChatStyles.usageCellPhoneText} numberOfLines={1}>{item.value}</Text>
          </View>
        ))}
      </View>
    );
  }

  return (
    <View style={[webChatStyles.usageStrip, isCompact && webChatStyles.usageStripCompact]}>
      {cards.map((item) => (
        <View
          key={item.key}
          testID={item.key === 'trial-chat' ? 'trial_chat_usage_badge' : undefined}
          style={webChatStyles.usageCard}
        >
          <View style={webChatStyles.usageCardHeader}>
            <View style={webChatStyles.usageIcon}>
              <MaterialIcons name={item.icon} size={17} color={reviewDesk.accent} />
            </View>
            <Text style={webChatStyles.usageLabel} numberOfLines={1}>{item.label}</Text>
          </View>
          <Text style={webChatStyles.usageValue} numberOfLines={1}>{item.value}</Text>
          <Text style={webChatStyles.usageMeta} numberOfLines={2}>{item.meta}</Text>
          <View style={webChatStyles.usageProgressTrack}>
            <View style={[webChatStyles.usageProgressFill, { width: `${item.percent}%` }]} />
          </View>
        </View>
      ))}
    </View>
  );
}
